import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import typographyStyles from '@root/styles/typography.module.less';
import Spinner from '@components/shared/Spinner';
import { buildingClicked } from '@store/actions/landlordPage/analyticsActions';
import s from './Portfolio.module.less';
import SelectedRegion from './SelectedRegion';
import Buildings from './Buildings';
import RegionButtonGroup from './RegionButtonGroup';
import useRegion from './useRegion';

type Props = {
  marketSlugs: string[];
  landlordSlug: string;
};

const Portfolio = ({ marketSlugs, landlordSlug }: Props) => {
  const { t } = useTranslation('landlord');
  const dispatch = useDispatch();

  const { selectedPortfolio, selectedRegionSlug, setSelectedRegionSlug } = useRegion(
    marketSlugs,
    landlordSlug,
  );

  const trackBuildingClick = building => {
    dispatch(buildingClicked(building));
  };

  if (marketSlugs.length < 1) return null;

  if (!selectedPortfolio) {
    return (
      <div className={s.spinnerContainer}>
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <section className={s.container}>
      <div className={s.header}>
        <h2 className={cn(typographyStyles.headerLargeSemibold, s.title)}>{t('ourPortfolio')}</h2>
        <RegionButtonGroup
          marketSlugs={marketSlugs}
          selectedRegionSlug={selectedRegionSlug}
          setSelectedRegionSlug={setSelectedRegionSlug}
        />
      </div>
      <div className={s.line} />
      <SelectedRegion
        hideRegionName={selectedRegionSlug === 'other' && marketSlugs.length === 1}
        selectedRegionSlug={selectedRegionSlug}
        portfolio={selectedPortfolio}
        buildingCount={selectedPortfolio.buildings.length}
      />
      <Buildings buildings={selectedPortfolio.buildings} onBuildingClick={trackBuildingClick} />
    </section>
  );
};

export default Portfolio;
